
import { mixins, Options, Prop, Watch } from 'vue-property-decorator'
import { Action } from 'vuex-class'
import { UEFA_ACTION, UEFA_NAMESPACE, UEFA_SEASON_ID, UefaTeamStatPayload, UefaTeamStatResult } from '../../store'

import UefaTeamTable from '../components/uefa/UefaTeamTable.vue'
import WidgetMixin, { WidgetMeta, widgetMetaFields } from './WidgetMixin'

export const meta: WidgetMeta = {
  label: 'UEFA - Tabella',
  fields: {
    ...widgetMetaFields,
    season: {
      type: 'select',
      default: Object.keys(UEFA_SEASON_ID)[0],
      props: {
        title: 'Szezon',
        items: Object.keys(UEFA_SEASON_ID)
      }
    }
  }
}

@Options({
  name: 'UefaTeamStatWidget',
  components: {
    UefaTeamTable
  }
})
export default class UefaTeamStatWidget extends mixins(WidgetMixin) {
  @Action(UEFA_ACTION.TEAM_STAT, { namespace: UEFA_NAMESPACE })
  storeFetchUefaTeamStat!: (payload: UefaTeamStatPayload) => Promise<UefaTeamStatResult>

  @Prop({
    type: String,
    default: Object.keys(UEFA_SEASON_ID)[0]
  })
  readonly season!: keyof typeof UEFA_SEASON_ID

  @Prop({
    type: Boolean,
    default: true
  })
  readonly showButton!: boolean

  get teamStat () {
    const data = this.$store.getters['$cache/result']([UEFA_NAMESPACE, UEFA_ACTION.TEAM_STAT], this.uefaTeamStatPayload)?.data

    if (data) {
      const rankings = data.stage[0].division.find((division: any) => division.type === 'total')?.ranking ?? []
      return rankings.map((ranking: any) => {
        return {
          name: ranking.contestantName,
          logo: `${this.$store.getters.getEnv('RTL_URL') ?? ''}/uefa/${this.season}/teams/${ranking.contestantShortName.replace('/', '-')}.png`,
          country: data.teams.find((team: any) => team.id === ranking.contestantId)?.country,
          matchesPlayed: ranking.matchesPlayed,
          matchesWon: ranking.matchesWon,
          matchesLost: ranking.matchesLost,
          matchesDrawn: ranking.matchesDrawn,
          goalsFor: ranking.goalsFor,
          goalsAgainst: ranking.goalsAgainst,
          goalDifference: ranking.goaldifference,
          points: ranking.points,
          results: [...ranking.lastSix?.slice(0, 5) ?? []].map((key: 'W' | 'L' | 'D') => {
            switch (key) {
              case 'W':
                return 'won'
              case 'L':
                return 'lost'
              case 'D':
                return 'drawn'
            }
          })
        }
      })
    }

    return []
  }

  get uefaTeamStatPayload (): UefaTeamStatPayload {
    return {
      season: UEFA_SEASON_ID[this.season],
    }
  }

  @Watch('uefaTeamStatPayload', { deep: true })
  async fetchUefaTeamStat () {
    if (this.uefaTeamStatPayload) {
      return this.storeFetchUefaTeamStat(this.uefaTeamStatPayload)
    }
  }

  serverPrefetch () {
    return this.fetchUefaTeamStat()
  }

  mounted () {
    return this.fetchUefaTeamStat()
  }
}
